module.exports = __webpack_public_path__ + "img/howitworks_seepoints_phone1.ab805058.jpg";